export enum ChildrenCareControlEnum{
  no_children = "no_children",
  no_children_below_21 = "no_children_below_21",
  full_custody_children = "full_custody_children",
  shared_control_children = "shared_control_children",
  no_control_children = "no_control_children"
}